import Header from '../Header/Header';
import { ICONS, Loader, Select } from '@ohif/ui';
import React, { useState, useEffect, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { ConfirmationPopup, SignaturePad } from '@ohif/ui';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import { SuccessModal } from '@ohif/ui';
import { customStyle } from '@custom/Utils/utils';
import { teleRadiologySchema } from './schema';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { AppDispatch, RootState } from '../store/store';
import { useDispatch, useSelector } from 'react-redux';
import addTeleraidologyCustomer from '@custom/rtk-apis/teleraidologycustomer/addeditteleradiologyCustomer';
import hospitalDetailApi from '@custom/rtk-apis/hospital/hospitalDetails';
import { TeleCustomerHospitalDetails } from '@custom/Utils/constants/interfaces';
import { SignatureDropzone } from '@custom/Profile';
import updateProfileImage from '@custom/rtk-apis/report/updateProfileImage';
import { useTheme } from "../../ui/src/contextProviders"

const defaultHospitalDetails: TeleCustomerHospitalDetails = {
  _id: '',
  customerType: '',
  diagnosticsType: '',
  hospitalName: '',
  hospitalEmailId: '',
  address: '',
  zipCode: '',
  country: '',
  state: '',
  city: '',
  website: '',
  contactNumberCountryCode: '',
  contactNumber: '',
  whatsappCountryCode: '',
  whatsappNumber: '',
  sameAsContact: false,
  emergencyContactCountryCode: '',
  emergencyContactNumber: '',
  radiologistNumber: '',
  signature: '',
  user: {
    _id: '',
    name: '',
    email: '',
    contactNumberCountryCode: '',
    contactNumber: '',
    whatsappCountryCode: '',
    whatsappNumber: '',
    sameAsContact: '',
  }
};

const Addteleradiology = () => {
  const navigate = useNavigate();
  const location = useLocation()
  const Role = sessionStorage.getItem("role") || localStorage.getItem('role');
  const imageResponse = useSelector((state: RootState) => state.updateProfileImageResponse);

  const dispatch = useDispatch<AppDispatch>();
  const { loading, error, data, message } = useSelector((state: RootState) => state.teleraidologySliceResponce);
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);

  const [countryCode, setCountryCode] = useState(['+91']); // Default country code
  const [countryList, setCountryList] = useState([])
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState("Record Created Successfully");
  const [load, setLoad] = useState(false)
  const [isTeleraidologiestAdminEdit, setIsTeleradiologiestAdminEdit] = useState(location?.state?.isTeleraidologiestAdminEdit ?? false)
  const [hospitalDetails, setHospitalDetails] = useState<HospitalDetails>(defaultHospitalDetails)
  const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
  const [hospitalDiagnosticsTypeOptions, setHospitalDiagnosticsTypeOptions] = useState([]);
  const [specialitites, setSpecialitities] = useState([]);
  const [folderName, setFolderName] = useState<string>('');
  const [isOpenSignaturePad, setOpenSignaturePad] = useState(false);
  const [signatureImage, setSignatureImage] = useState<string>('');
  const [profileImage, setProfileImage] = useState<string>('');
  const isDarkMode = useTheme();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [initialValues, setInitialValues] = useState({
    customerType: "",
    diagnosticsType: "",
    name: "",
    email: "",
    address: "",
    zipCode: "",
    country: "",
    state: "",
    city: "",
    website: "",
    contactNumberCountryCode: "+91",
    signature: "",
    contactNumber: "",
    whatsappCountryCode: "+91",
    whatsappNumber: "",
    sameAsContactNumber: false,
    emergencyContactNumberCountryCode: "+91",
    emergencyContactNumber: "",
    specialitites: [],
    radiologistNumber: "",
    superAdminName: "",
    superAdminEmail: "",
    superAdminContactNumberCountryCode: "+91",
    superAdminPhoneNumber: "",
    superAdminWhatsappNumberCountryCode: "+91",
    superAdminWhatsappNumber: "",
    superAdminSameAsContact: false,
  });

  const cancel = () => {
    navigate("/teleradiology");
  }

  const fetchStates = async (country, state, type) => {
    const response: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.statecity, body: { type: type, countryCode: country, stateCode: state }, headerType: 'json' })
    if (response?.status) {
      if (type === 'state') {
        setStates(response.result);
      } else {
        setCities(response.result);
      }
    }
  };

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        setCountryCode(commonData?.result?.countryCode);
        setCountryList(commonData?.result?.countryList);
        setCustomerTypeOptions(commonData?.result?.customerTypeOptions);
        setHospitalDiagnosticsTypeOptions(commonData?.result?.hospitalDiagnosticsTypeOptions);
        setSpecialitities(
          commonData?.result?.department?.map(item =>
            item === "Multi specality hospital"
              ? { value: "Multispeciality Hospital", label: "Multispeciality Hospital" }
              : { value: item, label: item }
          )
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const { teleraidologyCustomer } = location?.state || {}

  useEffect(() => {
    if (!location?.pathname.includes("/addTeleradiologycustomer")) {
      if (hospitalDetailsData?.status === 'SUCCESS' && hospitalDetailsData && Object.keys(hospitalDetailsData?.result).length > 0) {
        setHospitalDetails(hospitalDetailsData?.result);
        updateFormInitialValue(hospitalDetailsData?.result);
      }
    }
  }, [hospitalDetailsData, teleraidologyCustomer]);

  const updateFormInitialValue = (data) => {
    setInitialValues({
      customerType: data?.customerType || teleraidologyCustomer?.customerType || "",
      diagnosticsType: teleraidologyCustomer?.diagnosticsType || data?.diagnosticsType || "",
      name: teleraidologyCustomer?.name || data?.hospitalName || "",
      email: teleraidologyCustomer?.email || data?.hospitalEmailId || "",
      address: teleraidologyCustomer?.address || data?.address || "",
      zipCode: teleraidologyCustomer?.zipCode || data?.zipCode || "",
      country: teleraidologyCustomer?.country || data?.country || "",
      state: teleraidologyCustomer?.state || data?.state || "",
      city: teleraidologyCustomer?.city || data?.city || "",
      website: teleraidologyCustomer?.website || data?.website || "",
      signature: imageResponse?.result || "",
      specialitites: teleraidologyCustomer?.specialitites || data?.specialitites || [],
      contactNumberCountryCode: teleraidologyCustomer?.contactNumberCountryCode || data?.contactNumberCountryCode || "+91",
      contactNumber: teleraidologyCustomer?.contactNumber || data?.contactNumber || " ",
      whatsappCountryCode: teleraidologyCustomer?.whatsappCountryCode || data?.whatsappCountryCode || "+91",
      whatsappNumber: teleraidologyCustomer?.whatsappNumber || data?.whatsappNumber || "",
      sameAsContactNumber: teleraidologyCustomer?.sameAsContact || data?.sameAsContact || false,
      emergencyContactNumberCountryCode: teleraidologyCustomer?.emergencyContactCountryCode || data?.emergencyContactCountryCode || "+91",
      emergencyContactNumber: teleraidologyCustomer?.emergencyContactNumber || data?.emergencyContactNumber || "",
      radiologistNumber: teleraidologyCustomer?.radiologistNumber || data?.radiologistNumber || "",
      superAdminName: teleraidologyCustomer?.user?.name || data?.user?.name || "",
      superAdminEmail: teleraidologyCustomer?.user?.email || data?.user?.email || "",
      superAdminContactNumberCountryCode: teleraidologyCustomer?.user?.contactNumberCountryCode || data?.user?.contactNumberCountryCode || "+91",
      superAdminPhoneNumber: teleraidologyCustomer?.user?.contactNumber || data?.user?.contactNumber || "",
      superAdminWhatsappNumberCountryCode: teleraidologyCustomer?.user?.whatsappCountryCode || data?.user?.whatsappCountryCode || "+91",
      superAdminWhatsappNumber: teleraidologyCustomer?.user?.whatsappNumber || data?.user?.whatsappNumber || "",
      superAdminSameAsContact: teleraidologyCustomer?.user?.sameAsContact || data?.user?.sameAsContact || false,
    });
  };

  useEffect(() => {
    fetchCommonData()
    if (isTeleraidologiestAdminEdit || (Role === 'teraradiologysuperadmin' || Role === "Superadmin")) {
      const id = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const hospitalId = id ? id : location?.state?.hospitalId
      if (hospitalId) {
        dispatch(hospitalDetailApi({ hospitalId }));
      }
    }
  }, [isTeleraidologiestAdminEdit]);

  const handleSave = async (values: typeof initialValues) => {
    const customerData = {
      teraradiologyDetails: {
        zipCode: values?.zipCode,
        address: values?.address,
        customerType: values?.customerType,
        diagnosticsType: values?.diagnosticsType,
        hospitalName: values?.name,
        hospitalEmailId: values?.email,
        contactNumberCountryCode: values?.contactNumberCountryCode,
        state: values?.state,
        city: values?.city,
        contactNumber: values?.contactNumber,
        radiologistNumber: values?.radiologistNumber,
        sameAsContact: values?.sameAsContactNumber,
        country: values?.country,
        website: values?.website,
        specialitites: values?.specialitites,
        whatsappCountryCode: values?.whatsappCountryCode,
        whatsappNumber: values?.whatsappNumber,
        emergencyContactCountryCode: values?.emergencyContactNumberCountryCode,
        emergencyContactNumber: values?.emergencyContactNumber,
      },
      teraradiologyAdminDetails: {
        name: values?.superAdminName,
        email: values?.superAdminEmail,
        contactNumberCountryCode: values?.contactNumberCountryCode,
        contactNumber: values?.superAdminPhoneNumber,
        whatsappCountryCode: values?.contactNumberCountryCode,
        whatsappNumber: values?.superAdminWhatsappNumber,
        sameAsContact: values?.superAdminSameAsContact,
        signature: imageResponse.result,
      },
    };
    if (teleraidologyCustomer?._id) {
      customerData.teraradiologyDetails["_id"] = teleraidologyCustomer ? teleraidologyCustomer?._id : null
    } else if (hospitalDetails?._id) {
      customerData.teraradiologyDetails["_id"] = hospitalDetails ? hospitalDetails?._id : null
    }
    if (teleraidologyCustomer?.user?._id) {
      customerData.teraradiologyAdminDetails["_id"] = teleraidologyCustomer?.user ? teleraidologyCustomer?.user?._id : null
    } else if (hospitalDetails?.user?._id) {
      customerData.teraradiologyAdminDetails["_id"] = hospitalDetails?.user ? hospitalDetails?.user?._id : null
    }
    setLoad(true)
    const response = await dispatch(addTeleraidologyCustomer(customerData)).unwrap();
    if (response?.status === "SUCCESS") {
      setTitle(response.msg.replace('update', 'updated'));
      setModal(true);
      setLoad(false);
      setTimeout(() => {
        setModal(false);
        if (Role === "teraradiologysuperadmin" && isTeleraidologiestAdminEdit) {
          setIsTeleradiologiestAdminEdit(false);
          navigate('/editTeleradiology');
        } else if (Role !== "teraradiologysuperadmin") {
          navigate("/teleradiology");
        } else {
          setIsTeleradiologiestAdminEdit(false);
          window.location.reload(); // Reload the window
        }
      }, 500);

    } else {
      setLoad(false);
    }
  };

  useEffect(() => {
    const processDetails = (details: any) => {
      if (details && Object.keys(details).length > 0) {
        if (details?.country) {
          fetchStates(details?.country, '', 'state');
        }
        if (details?.country && details?.state) {
          fetchStates(details?.country, details?.state, 'city');
        }
      }
    };

    // Process both datasets
    processDetails(hospitalDetails);
    processDetails(teleraidologyCustomer);
  }, [hospitalDetails, teleraidologyCustomer]);

  const uploadSignatureFile = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        //setFieldValue('signature', reader.result); // Base64 string
        //  setPreview(reader.result);
        setFolderName("signature")
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folderName', "signature");

        dispatch(updateProfileImage(formData))
          .unwrap()
          .then((result) => {
            console.log('File uploaded successfully:', result);
          })
          .catch((error) => {
            console.error('Error uploading file:', error);
          });
      };
      reader.readAsDataURL(file); // Convert the file to Base64
    }
  }

  const onDrop = useCallback((acceptedFiles, setFieldValue) => {
    const file = acceptedFiles[0];
    uploadSignatureFile(file)
  }, []);

  useEffect(() => {
    if (imageResponse?.status === "SUCCESS") {
      if (folderName === 'profile') {
        setProfileImage(imageResponse?.result)
      }
      else {
        setSignatureImage(imageResponse?.result)
        setInitialValues((prevValue) => ({
          ...prevValue,
          signature: imageResponse?.result
        }));
      }
    }
  }, [imageResponse])

  const base64ToBlob = (base64, type = 'image/png') => {
    const byteCharacters = atob(base64.split(',')[1]); // Decode base64 string
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type });
  };

  const saveSignature = (signatureData) => {
    setOpenSignaturePad(false)
    const blob = base64ToBlob(signatureData); // Convert base64 to Blob
    const file = new File([blob], `signature_${Date.now()}.png`, { type: 'image/png' }); // Create a File object
    uploadSignatureFile(file)
  };

  const openSignaturePad = () => {
    setOpenSignaturePad(true)
  }

  return (
    <>
      <div className='page page__full' style={
        isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        {Role === "teraradiologysuperadmin" ? (
          isTeleraidologiestAdminEdit ? (
            <Header isBack={true} title="Edit Teleradiology Profile" handleIsBackFunctionality={() => setIsTeleradiologiestAdminEdit(false)} />
          ) : (
            <Header isBack={false} title=" Teleradiology Profile" />
          )
        ) : Role === "Superadmin" ? (
          isTeleraidologiestAdminEdit ? (
            <Header isBack={true} title="Edit Teleradiology User" />
          ) : (
            <Header isBack={true} title="Add Teleradiology User" />
          )
        ) : null}
        <div className='page__body'>
          <div className='details'>
            <div className='form form-innersec'>
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={teleRadiologySchema}
                onSubmit={handleSave}
              >
                {({
                  errors,
                  values,
                  handleChange,
                  handleBlur,
                  touched,
                  setFieldValue,
                  setFieldTouched,
                }) => {
                  return (
                    <Form >
                      <section className='form__section'>
                        {Role === "teraradiologysuperadmin" ?
                          <div className='flex justify-between items-center'>
                            {!isTeleraidologiestAdminEdit ? <h1 className='form__section__title'>Profile Details</h1> : <h1 className='form__section__title'>Edit Profile Details</h1>}
                            {!isTeleraidologiestAdminEdit &&
                              <button className="custom-button main-theme flex items-center" onClick={() => setIsTeleradiologiestAdminEdit(true)}>
                                <img src={ICONS["edit"]} alt="edit" style={{ filter: "brightness(0) invert(1)" }} className="mr-2" />
                                Edit
                              </button>
                            }
                          </div>
                          :
                          ""
                        }
                        <div className='formRow formRow__4'>
                          <div className="formCol">
                            <div className="form__Field">
                              <label className='form__label' htmlFor='customerType'>
                                User Type
                                <span className="required-asterisk">*</span>
                              </label>
                              <select
                                style={customStyle.select}
                                id="customerType"
                                name="customerType"
                                className="form__select form__select--sm"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.customerType}
                                autoComplete='off'
                              >
                                <option value="" disabled={true}>Select</option>
                                {customerTypeOptions.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <ErrorMessage name="customerType" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className="formCol">
                            <div className="form__Field">
                              <label htmlFor='diagnosticsType' className='form__label'>
                                Hospital/Diagnostics Type
                                <span className="required-asterisk">*</span>
                              </label>
                              <select
                                style={customStyle.select}
                                id="diagnosticsType"
                                name="diagnosticsType"
                                className="form__select form__select--sm"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.diagnosticsType}
                                autoComplete='off'
                              >
                                <option value="" disabled={true}>Select</option>
                                {hospitalDiagnosticsTypeOptions.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              <ErrorMessage name="diagnosticsType" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className="formCol">
                            <div className="form__Field">
                              <label className="form__label" htmlFor='hospitalName'>
                                Name
                                <span className="required-asterisk">*</span>
                              </label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                                autoComplete='off'
                                disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                              />
                              <ErrorMessage name="name" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" >
                                Email ID<span className="required-asterisk">*</span>
                              </label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="email"
                                name="email"
                                placeholder="Email ID"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                autoComplete='off'
                                disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                              />
                              <ErrorMessage name="email" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                        <div className="formRow formRow__4">
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='zipCode'>Zip Code</label>
                                <input
                                  className="form__input form__input--sm"
                                  type="text"
                                  id="zipCode"
                                  name="zipCode"
                                  placeholder="Zip Code"
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/[^0-9]/g, '');
                                    e.target.value = value;
                                    handleChange(e);
                                  }}
                                  onBlur={handleBlur}
                                  maxLength={6}
                                  value={values.zipCode}
                                  pattern="[0-9]*"
                                  inputMode="numeric"
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                />
                              </div>
                              <ErrorMessage name="zipCode" component="div" className="error text-error" />
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='country' >Country</label>
                                <select
                                  id="country"
                                  name="country"
                                  className="form__select form__select--sm"
                                  onChange={(e) => {
                                    handleChange(e);
                                    fetchStates(e.target.value, '', 'state')
                                  }}
                                  onBlur={handleBlur}
                                  value={values.country}
                                  autoComplete='off'
                                  style={customStyle.select}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                  <option value="">Select</option>
                                  {countryList.map((option) => (
                                    <option key={option.value} value={option.value}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='state'>State</label>
                                <select
                                  style={customStyle.select}
                                  id="state"
                                  name="state"
                                  className="form__select form__select--sm"
                                  onChange={(e) => {
                                    handleChange(e);
                                    fetchStates(values.country, e.target.value, 'city')
                                  }}
                                  onBlur={handleBlur}
                                  value={values.state}
                                  autoComplete='off'
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                  <option value="">Select</option>
                                  {states.map((option) => (
                                    <option key={option.isoCode} value={option.isoCode}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className='formCol'>
                              <div className='form__Field'>
                                <label className="form__label" htmlFor='city'>City</label>
                                <select
                                  style={customStyle.select}
                                  id="city"
                                  name="city"
                                  className="form__select form__select--sm"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.city}
                                  autoComplete='off'
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                  <option value="">Select</option>
                                  {cities.map((option) => (
                                    <option key={option.name} value={option.name}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                        </div>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='address'>Address</label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="address"
                                name="address"
                                placeholder="Address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.address}
                                autoComplete='off'
                                disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                              />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='website'>Website</label>
                              <input
                                className="form__input form__input--sm"
                                type="text"
                                id="website"
                                placeholder="Website"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.website}
                                autoComplete='off'
                                disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                              />
                            </div>
                          </div>
                          <div className='formCol'>
                                <div className="form__Field">
                                  <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>No. of Radiologist</label>
                                  <input
                                    className='form__input form__input--sm'
                                    type="number"
                                    id="radiologistNumber"
                                    name="radiologistNumber"
                                    min="0"
                                    step="1"
                                    placeholder="--"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.radiologistNumber}
                                    autoComplete='off'
                                    disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                  />
                                </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='specialitites'>Specialties
                                <span className="required-asterisk">*</span></label>
                              <Select
                                id='specialitites'
                                placeholder="Select"
                                className={`${Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit ? "input-disabled" : ""} cutom-bg-white `}
                                isMulti={true}
                                isClearable={false}
                                isSearchable={false}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                isDisabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                options={specialitites}
                                value={values.specialitites}
                                onChange={(selectedOptions) => {
                                  const newSpecialties = selectedOptions ? selectedOptions.map(option => option) : [];
                                  setFieldValue('specialitites', newSpecialties);
                                }
                                }
                              ></Select>
                              <ErrorMessage name="specialitites" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                        <div className='formRow formRow__4'>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='contactNumber'>Contact Number
                                <span className="required-asterisk">*</span>
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select
                                  className='form__select form__select--sm'
                                  style={customStyle.select}
                                  id="contactNumberCountryCode"
                                  value={values.contactNumberCountryCode}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (values.sameAsContactNumber) {
                                      setFieldValue('whatsappNumber', values?.contactNumber);
                                      setFieldValue('whatsappCountryCode', e.target.value);
                                    }
                                  }}>
                                  {
                                    countryCode.map((option) => (<option value={option}>{option}</option>))
                                  }
                                </select>
                                <input
                                  className='form__input form__input--sm'
                                  type="text"
                                  id="contactNumber"
                                  name="contactNumber"
                                  placeholder="Contact Number"
                                  maxLength={10}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange(e);
                                  }}
                                  pattern="[0-9]*"
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (values.sameAsContactNumber) {
                                      setFieldValue('whatsappNumber', e.target.value);
                                      setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode);
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  value={values.contactNumber}
                                >
                                </input>
                              </div>
                              <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select
                                  className="form__select form__select--sm"
                                  style={customStyle.select}
                                  id="whatsappCountryCode"
                                  name="whatsappCountryCode"
                                  value={values.whatsappCountryCode}
                                  onChange={handleChange}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                  {
                                    countryCode.map((option) => (<option value={option}>{option}</option>))
                                  }
                                </select>
                                <input
                                  type="text"
                                  className='form__input form__input--sm'
                                  id="whatsappNumber"
                                  name="whatsappNumber"
                                  maxLength={10}
                                  placeholder="Whatsapp Number"
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange(e);
                                  }}
                                  pattern="[0-9]*"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.whatsappNumber}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                </input>
                              </div>
                              <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                              <div className="form__checkboxSubField">
                                <div className="form__checkbox">
                                  <div className="form__checkbox__option m_0">
                                    <input className="form__checkbox__input"
                                      id="sameAsContact"
                                      type="checkbox"
                                      name="sameAsContact"
                                      checked={values.sameAsContactNumber || (values.contactNumber && values.whatsappNumber && values.contactNumber === values.whatsappNumber)}  // Set checked based on the condition
                                      disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                      onChange={(e) => {
                                        setFieldValue('sameAsContact', e.target.checked);
                                        if (e.target.checked) {
                                          setFieldValue('whatsappNumber', values.contactNumber);
                                          setFieldValue('whatsappCountryCode', values?.contactNumberCountryCode);
                                        } else {
                                          setFieldValue('whatsappNumber', '');
                                          setFieldValue('whatsappCountryCode', '');
                                        }
                                      }} />
                                    <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="formCol">
                            <div className="form__Field">
                              <label className="form__label" htmlFor='emergencyNumber'>Emergency Contact Number</label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select
                                  className='form__select form__select--sm'
                                  style={customStyle.select}
                                  id="emergencyContactNumberCountryCode"
                                  value={values.emergencyContactNumberCountryCode}
                                  onChange={handleChange}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                  {
                                    countryCode.map((option) => (<option value={option}>{option}</option>))
                                  }
                                </select>
                                <input
                                  type="text"
                                  className='form__input form__input--sm'
                                  id="emergencyContactNumber"
                                  name="emergencyContactNumber"
                                  placeholder='Emergency Contact Number'
                                  maxLength={10}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.emergencyContactNumber}
                                  autoComplete='off'
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                </input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>

                      {/* <hr className='h-2' style={{ backgroundColor: "#0f8491", opacity: "15%" }} /> */}
                      {/* --------- Super Admin -------- */}
                      <section className='form__section'>
                        <h1 className='form__section__title'>Super Admin Details</h1>
                        <div className='formRow formRow__4'>
                          <div className="formCol">
                            <div className="form__Field">
                              <label className="form__label" htmlFor='superAdminName'>Name<span className="required-asterisk">*</span>
                              </label>
                              <input
                                type="text"
                                className='form__input form__input--sm'
                                id="superAdminName"
                                name="superAdminName"
                                placeholder="Name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.superAdminName}
                                autoComplete='off'
                                disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                              />
                              <ErrorMessage name="superAdminName" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='superAdminEmail'>
                                Email ID
                                <span className="required-asterisk">*</span>
                              </label>
                              <input
                                type="text"
                                className='form__input form__input--sm'
                                id="superAdminEmail"
                                name="superAdminEmail"
                                placeholder="Email ID"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.superAdminEmail}
                                autoComplete='off'
                                disabled={isTeleraidologiestAdminEdit}
                              />
                              <ErrorMessage name="superAdminEmail" component="div" className="error text-error" />
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className="form__Field">
                              <label className="form__label" htmlFor='superAdminContactNumber'>Contact Number
                                <span className="required-asterisk">*</span>
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select
                                  className='form__select form__select--sm'
                                  style={customStyle.select}
                                  id="superAdminContactNumberCountryCode"
                                  value={values.superAdminContactNumberCountryCode}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (values.superAdminSameAsContact) {
                                      setFieldValue('superAdminWhatsappNumber', values?.superAdminContactNumber);
                                      setFieldValue('superAdminWhatsappNumberCountryCode', e.target.value);
                                    }
                                  }}>
                                  {
                                    countryCode.map((option) => (<option value={option}>{option}</option>))
                                  }
                                </select>
                                <input
                                  className='form__input form__input--sm'
                                  type="text"
                                  id="superAdminPhoneNumber"
                                  name="superAdminPhoneNumber"
                                  placeholder="Contact Number"
                                  maxLength={10}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange(e);
                                  }}
                                  pattern="[0-9]*"
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (values.superAdminSameAsContact) {
                                      setFieldValue('superAdminWhatsappNumber', e.target.value);
                                      setFieldValue('superAdminWhatsappNumberCountryCode', values?.superAdminContactNumberCountryCode);
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  value={values.superAdminPhoneNumber}
                                >
                                </input>
                              </div>
                              <ErrorMessage name="superAdminPhoneNumber" component="div" className="error text-error" />

                            </div>
                          </div>
                          <div className="formCol">
                            <div className="form__Field">
                              <label className="form__label" htmlFor='superAdminWhatsappNumber'>Whatsapp Number
                                <span className="required-asterisk">*</span>
                              </label>
                              <div className='form__groupField form__groupField--phonenumber'>
                                <select className='form__select form__select--sm'
                                  style={customStyle.select}
                                  id="superAdminWhatsappNumberCountryCode"
                                  value={values.superAdminWhatsappNumberCountryCode}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                  onChange={handleChange}>
                                  {
                                    countryCode.map((option) => (<option value={option}>{option}</option>))
                                  }
                                </select>
                                <input
                                  type="text"
                                  className='form__input form__input--sm'
                                  id="superAdminWhatsappNumber"
                                  name="superAdminWhatsappNumber"
                                  placeholder="Whatsapp Number"
                                  maxLength={10}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange(e);
                                  }}
                                  pattern="[0-9]*"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.superAdminWhatsappNumber}
                                  disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                >
                                </input>
                              </div>
                              <div className="form__checkboxSubField">
                                <div className="form__checkbox">
                                  <div className="form__checkbox__option m_0">
                                    <input className='form__checkbox__input'
                                      id='superAdminSameAsContact'
                                      checked={values.superAdminPhoneNumber && values.superAdminWhatsappNumber && values.superAdminPhoneNumber === values.superAdminWhatsappNumber}
                                      type="checkbox" name="superAdminSameAsContact"
                                      value="superAdminSameAsContact"
                                      disabled={Role === "teraradiologysuperadmin" && !isTeleraidologiestAdminEdit}
                                      onChange={(e) => {
                                        setFieldValue('superAdminSameAsContact', e.target.checked);
                                        if (e.target.checked) {
                                          setFieldValue('superAdminWhatsappNumber', values?.superAdminPhoneNumber);
                                          setFieldValue('superAdminWhatsappNumberCountryCode', values?.superAdminContactNumberCountryCode)
                                        } else {
                                          setFieldValue('superAdminWhatsappNumber', '');
                                          setFieldValue('superAdminWhatsappNumberCountryCode', '')
                                        }
                                      }} />
                                    <label htmlFor="sameAsContact" className="form__checkbox__label"> Same as Contact Number</label>
                                  </div>
                                </div>
                              </div>
                              <ErrorMessage name="superAdminWhatsappNumber" component="div" className="error text-error" />
                            </div>
                          </div>
                        </div>
                        {Role !== "Superadmin" ? (
                          <div className="formRow">
                            <div className="formCol">
                              <div className="form__Field">
                                {isTeleraidologiestAdminEdit && (
                                  <label className="form__label" className='form__Label' htmlFor='signature'>
                                    Add/Upload Signature
                                    {Role !== "Front Desk" && <span className="required-asterisk">*</span>}
                                  </label>
                                )}
                                <div className={`relative ${!isTeleraidologiestAdminEdit ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
                                  <SignatureDropzone
                                    onDrop={(acceptedFiles) => onDrop(acceptedFiles, setFieldValue)}
                                    preview={values?.signature}
                                    accept={{ 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] }}
                                  />
                                </div>
                                {isTeleraidologiestAdminEdit && (
                                  <>
                                    <div>
                                      <p className="addSignatureNote" style={{ color: isDarkMode?.isDarkMode ? '#ffffff' : '#a00000' }}> Note: Please use a black pen and white paper to sign </p>
                                      <p className='addSignatureDiv -mt-2'>Or</p>
                                    </div>
                                    <div className='addSignatureDiv'>
                                      <button
                                        className="btn btn__white"
                                        type="button"
                                        onClick={openSignaturePad}
                                        style={!isTeleraidologiestAdminEdit ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                      >
                                        Add Signature
                                      </button>
                                    </div>
                                  </>
                                )}
                                <ErrorMessage name="signature" component="div" className="error text-error" />
                              </div>
                            </div>
                          </div>
                        ) : <></>}
                        <div className='btn__group'>
                          {Role !== "teraradiologysuperadmin" &&
                            <button
                              className='mr-2 custom-button'
                              onClick={cancel}
                            >
                              Cancel
                            </button>
                          }
                          {Role === "teraradiologysuperadmin" ?
                            (isTeleraidologiestAdminEdit &&
                              <>

                                <button
                                  className='btn btn__primary'
                                  type="submit"
                                >
                                  Update
                                </button>
                                <button
                                  className='btn btn__white'
                                  onClick={() => {
                                    window.location.reload();
                                  }}
                                >
                                  Cancel
                                </button>
                              </>
                            )
                            :
                            <button
                              className='btn btn__primary'
                              type="submit"
                            >
                              {isTeleraidologiestAdminEdit ? 'Update' : 'Save'}
                            </button>
                          }
                        </div>
                      </section>
                    </ Form>
                  )
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationPopup
        title={title}
        message={confirmationText}
        onCancel={() => {
          setTitle('');
          setConfirmationText('');
          setConfirmationModal(false);
        }}
        isOpen={confirmationModal}
        onConfirm={undefined}
      />
      <SignaturePad title={title}
        message={confirmationText}
        onConfirm={saveSignature}
        onCancel={() => {
          setOpenSignaturePad(false)
        }}
        isOpen={isOpenSignaturePad}>
      </SignaturePad>
      <SuccessModal
        isSuccessModalOpen={modal}
        title={title}
        handleCloseModal={() => setModal(false)}
      />
      <Loader isLoaderOpen={loading || load || hospitalDetailsData?.loading} />
    </>
  )
}

export default Addteleradiology
